import {BaseModel} from '@/core/standard/BaseModel'; 
import UserTimeTrackingService from '@/modules/users/userTimeTracking/UserTimeTrackingService';
import { IUserTimeTrackingModel, UserTimeTrackingProtocol, IUserTimeTracking  } from '@/modules/users/userTimeTracking/IUserTimeTrackingModel';

const timeTracking = {
    id: null,
    is_active: false,
    start_time: "",
    end_time: "",
    signed_by_id: null,
    email: "",
    password: "",
};

class UserTimeTrackingModel extends BaseModel< IUserTimeTracking, UserTimeTrackingProtocol> {
    id= 0;
    is_active= false;
    start_time= "";
    end_time= "";
    signed_by_id= null;
    email= "";
    password= "";
    public modelName = 'userTimeTracking';

    public request = 'JSON';

    constructor() {
      super(timeTracking, UserTimeTrackingService);
    }

    public async checkUser(query) {
      return await UserTimeTrackingService.checkUser(query);
    }

    public async updateSession(query) {
        return await UserTimeTrackingService.request({ url: query.id, query, method: "PUT" });
    }

}

export default UserTimeTrackingModel as new () => IUserTimeTracking;
